import React from 'react';
import {observable} from 'mobx';
import {observer, inject} from 'mobx-react';

const MessagesPerSecond = inject('store')(observer(({store = {}}) => {
    return store._messagesPerSecond.toLocaleString();
}));


export default MessagesPerSecond;



// WEBPACK FOOTER //
// ./src/app/components/MessagesPerSecond.js